import type { PlayerType } from "../../../royalur/model/PlayerType.js";
import type { PlayerNo } from "../../game/PlayerNo.js";
import { isSameRuntimeType } from "../../../util/tsutils.js";

/**
 * Stores metadata about a player in a game.
 */
export class GamePlayerData {
    private readonly playerNo: PlayerNo;
    private readonly playerType: PlayerType;

    constructor(
        playerNo: PlayerNo,
        playerType: PlayerType,
    ) {
        this.playerNo = playerNo;
        this.playerType = playerType;
    }

    getPlayerNo(): PlayerNo {
        return this.playerNo;
    }

    getPlayerType(): PlayerType {
        return this.playerType;
    }

    equals(other: unknown): boolean {
        if (other === this)
            return true;
        if (!isSameRuntimeType(this, other))
            return false;

        return this.playerNo === other.playerNo
            && this.playerType === other.playerType;
    }
}
